<template>
  <div class="section-wrapper">
 <div class="sec8-trigger"></div>
    <div class="sec-8-title">
      <h2>Sprzęt Amica testowali między innymi:</h2>
      <span class="scroll-info">scroll &raquo;</span>
    </div>

    <div class="sec-8-table-wraper">
      <table class="sec-8-table">
        <thead>
          <tr>
            <th></th>
            <th>Krzysztof</th>
            <th>Diana</th>
            <th>Magda</th>
            <th>Agnieszka</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="31.28"
                height="31.28"
                viewBox="0 0 31.28 31.28"
              >
                <g transform="translate(0.75 0.75)">
                  <g transform="translate(0 0)">
                    <ellipse class="a" cx="13.334" cy="13.334" rx="13.334" ry="13.334" />
                    <line class="a" x1="6.663" y1="6.665" transform="translate(23.337 23.335)" />
                  </g>
                  <path
                    class="a"
                    d="M68.4,79.183l4.163,4.163,8.329-8.327"
                    transform="translate(-60.456 -66.45)"
                  />
                </g>
              </svg>Testuje
            </th>
            <td>Piekarnik oraz płytę indukcyjną</td>
            <td>Piekarnik pod zabudowę</td>
            <td>Kuchenkę gazową</td>
            <td>Kuchenkę wolnostojącą ceramiczną</td>
          </tr>
          <tr>
            <th>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="41.557"
                height="31.617"
                viewBox="0 0 41.557 31.617"
              >
                <g transform="translate(0.807 0.833)">
                  <g transform="translate(0 0)">
                    <path
                      class="a"
                      d="M53.062,73.637a1.6,1.6,0,0,1-.53-1.052c-.062-.631-.143-1.258-.213-1.89-.083-.759-.164-1.517-.25-2.276-.062-.562-.132-1.124-.2-1.686-.028-.234-.058-.465-.093-.7a1.667,1.667,0,0,0-.664-1.071,5.042,5.042,0,0,0-2.077-.939,9.511,9.511,0,0,0-2.646-.213,7.967,7.967,0,0,0-2.29.414,3.717,3.717,0,0,0-1.751,1.129,1.666,1.666,0,0,0-.305.867c-.076.55-.125,1.1-.176,1.656-.042.433-.086.867-.123,1.3-.044.495-.106.99-.15,1.487-.049.52-.081,1.043-.127,1.564-.037.428-.1.856-.118,1.286-.016.321-.056.638-.072.96-.021.435-.067.867-.106,1.3a.247.247,0,0,1-.09.171q-.607.517-1.207,1.036a1.407,1.407,0,0,1-.574.261"
                      transform="translate(-32.674 -57.014)"
                    />
                    <path
                      class="a"
                      d="M114.282,77.952c-.025-.046-.06-.037-.095-.046a1.659,1.659,0,0,1-.668-.384c-.46-.449-.927-.89-1.392-1.332a.476.476,0,0,1-.141-.264c-.451-1.971-.9-3.941-1.409-5.9-.245-.946-.5-1.887-.8-2.819a3.377,3.377,0,0,0-1.568-1.934,4.538,4.538,0,0,0-1.8-.627,4.309,4.309,0,0,0-3.081.657,3.411,3.411,0,0,0-1.381,1.827c-.224.712-.421,1.432-.618,2.151-.227.833-.43,1.672-.645,2.509-.132.509-.259,1.02-.37,1.533a1.475,1.475,0,0,1-.391.71"
                      transform="translate(-80.624 -57.645)"
                    />
                    <path
                      class="a"
                      d="M106.183,89.26a10.717,10.717,0,0,1,.081,1.982,8.786,8.786,0,0,1-.37,2.461c-.229.715-.458,1.429-.715,2.135-.31.856-.631,1.709-.925,2.572a1.331,1.331,0,0,0-.06.247c-.019.13-.069.284.035.382a.869.869,0,0,0,.474.238,10.871,10.871,0,0,0,1.425.076.617.617,0,0,1,.093,0,.387.387,0,0,1,.386.433c.021.562.03,1.124.035,1.686.007.775.018,1.547.035,2.322.014.583.007,1.166.028,1.749q.031.905.028,1.811c0,.093.009.185.014.278"
                      transform="translate(-83.352 -77.636)"
                    />
                    <path
                      class="a"
                      d="M57.582,88.86c-.035,2.671-.016,5.345-.009,8.016,0,.759.079,1.517.118,2.276.021.4.03.8.049,1.191.03.661.062,1.321.093,1.982.028.594.049,1.187.079,1.781.037.754.09,1.506.118,2.26.009.273.035.546.035.821"
                      transform="translate(-46.768 -77.328)"
                    />
                    <path
                      class="a"
                      d="M84.827,89c0,.072-.007.143-.007.217,0,2.692,0,5.387,0,8.079,0,.578-.069,1.156-.083,1.735-.007.289-.028.578-.037.867-.023.578-.069,1.156-.086,1.735-.007.294-.025.587-.037.881-.023.583-.072,1.166-.086,1.749-.007.289-.028.578-.037.867-.023.578-.06,1.156-.09,1.735-.007.143,0,.289,0,.433"
                      transform="translate(-67.759 -77.436)"
                    />
                    <path
                      class="a"
                      d="M168.986,112.162c0-.273-.016-.546-.025-.821-.025-.759-.049-1.517-.079-2.276-.025-.655-.06-1.311-.093-1.966-.007-.15-.032-.3-.044-.449a1.05,1.05,0,0,0-.576-.786,3.627,3.627,0,0,0-1.607-.523,6.629,6.629,0,0,0-2.863.213,3.111,3.111,0,0,0-.777.382,1.078,1.078,0,0,0-.49.842c-.053.541-.1,1.082-.141,1.626a1.528,1.528,0,0,1-.31.789"
                      transform="translate(-128.986 -89.392)"
                    />
                    <path
                      class="a"
                      d="M15.031,109.773a2.21,2.21,0,0,1-.5-1.057c-.134-.446-.257-.9-.435-1.33a1.536,1.536,0,0,0-.6-.666,3.345,3.345,0,0,0-2.151-.6,2.749,2.749,0,0,0-2.075,1.032,2.086,2.086,0,0,0-.31.726c-.308,1.066-.555,2.149-.791,3.233q-.219,1.006-.433,2.012a1.384,1.384,0,0,0-.016.171"
                      transform="translate(-7.72 -90.063)"
                    />
                    <path
                      class="a"
                      d="M136.307,89.26c-.014.16-.019.321-.039.479a5.924,5.924,0,0,0-.055.99,12.462,12.462,0,0,0,.2,2.213,20.133,20.133,0,0,0,.726,2.368c.382,1.08.775,2.156,1.156,3.236a1,1,0,0,1,.032.324c0,.2-.164.268-.31.338a1.062,1.062,0,0,1-.308.083,7.909,7.909,0,0,1-1.237.06c-.046,0-.093,0-.139,0-.34.049-.46.208-.465.618,0,.382.012.763,0,1.145-.028.7-.009,1.395-.035,2.089-.021.615,0,1.228-.03,1.841-.025.655-.021,1.311-.028,1.966,0,.206-.019.412-.03.62"
                      transform="translate(-108.113 -77.636)"
                    />
                    <path
                      class="a"
                      d="M31.867,120.92c-.023.278-.067.557-.065.835a6.61,6.61,0,0,0,.352,2.213q.385,1.075.775,2.151a1.461,1.461,0,0,1,.079.527.194.194,0,0,1-.109.171.894.894,0,0,1-.481.155.853.853,0,0,0-.109,0c-.345.039-.476.192-.479.557s.012.712,0,1.069c-.03.68-.014,1.362-.032,2.042-.012.444-.025.888-.025,1.332"
                      transform="translate(-26.207 -101.973)"
                    />
                    <path
                      class="a"
                      d="M13.187,121.05a6.952,6.952,0,0,1,.025,1.626,9.122,9.122,0,0,1-.585,2.2c-.153.465-.342.918-.5,1.381a1.19,1.19,0,0,0-.069.463.236.236,0,0,0,.143.231.893.893,0,0,0,.433.125.57.57,0,0,1,.109,0c.377.053.488.206.495.68,0,.372-.012.742,0,1.115.025.7.019,1.392.032,2.089.007.372.028.742.025,1.115"
                      transform="translate(-11.05 -102.073)"
                    />
                    <path
                      class="a"
                      d="M169.54,121.05a.331.331,0,0,1,.014.171c0,1.619-.007,3.24,0,4.859,0,.578.065,1.156.086,1.735.009.259.023.516.035.775.028.62.049,1.24.09,1.857.016.236.012.474.03.712.023.3.023.608.035.914"
                      transform="translate(-134.798 -102.073)"
                    />
                    <path
                      class="a"
                      d="M185.024,121.05a.331.331,0,0,0-.014.171c0,1.619.007,3.24,0,4.859,0,.578-.065,1.156-.086,1.735-.009.259-.023.516-.035.775-.028.62-.046,1.24-.09,1.857-.016.227-.016.453-.03.68-.023.315-.023.629-.035.944"
                      transform="translate(-146.475 -102.073)"
                    />
                    <path
                      class="a"
                      d="M71.97,122.72c0,.093.014.185.014.278v9.612c0,.171-.009.34-.014.511"
                      transform="translate(-58.045 -103.357)"
                    />
                    <path
                      class="a"
                      d="M125.37,131.96c0,.093.014.185.014.278v7.475c0,.171-.009.34-.014.511"
                      transform="translate(-99.871 -110.46)"
                    />
                    <path
                      class="a"
                      d="M177.77,140.59v6.238"
                      transform="translate(-141.124 -117.094)"
                    />
                    <path
                      class="a"
                      d="M24.76,146.61c0,.058.007.113.007.171v4.674"
                      transform="translate(-20.819 -121.721)"
                    />
                    <path
                      class="a"
                      d="M18.289,84.575a1.8,1.8,0,0,0-1.207.7,1.681,1.681,0,0,0-.359,1.221,1.717,1.717,0,0,0,1.163,1.531,1.737,1.737,0,0,0,1.978-.527,1.7,1.7,0,0,0,.356-1.605,1.757,1.757,0,0,0-1.73-1.316c-.062,0-.125,0-.185,0"
                      transform="translate(-14.635 -73.031)"
                    />
                    <path
                      class="a"
                      d="M171.3,83.836a1.74,1.74,0,0,0-1.418.932,1.781,1.781,0,0,0,2.891,2.042,1.776,1.776,0,0,0-.266-2.63,1.757,1.757,0,0,0-1.189-.342"
                      transform="translate(-134.885 -72.451)"
                    />
                    <path
                      class="a"
                      d="M115.1,32.087a3.091,3.091,0,0,0-1.316.465,2.962,2.962,0,0,0-.527,4.568,2.832,2.832,0,0,0,1.612.863,2.894,2.894,0,0,0,2.831-1.066,2.8,2.8,0,0,0,.661-1.871,2.91,2.91,0,0,0-.77-1.982,2.969,2.969,0,0,0-1.9-.971,4.7,4.7,0,0,0-.571,0"
                      transform="translate(-89.966 -31.9)"
                    />
                    <path
                      class="a"
                      d="M61.783,31.3a3.1,3.1,0,0,0-1.425.509,2.975,2.975,0,0,0,.331,5.132,2.986,2.986,0,0,0,4.3-2.484,2.864,2.864,0,0,0-.555-1.917,2.906,2.906,0,0,0-1.638-1.133,3.413,3.413,0,0,0-.99-.106"
                      transform="translate(-48.038 -31.303)"
                    />
                  </g>
                </g>
              </svg>Rodzina
            </th>
            <td>Żona Agnieszka i&nbsp;syn</td>
            <td>Mąż Wojtek</td>
            <td>Mąż Tomasz i dwoje dzieci</td>
            <td>Partner i syn</td>
          </tr>
          <tr>
            <th>
           <svg xmlns="http://www.w3.org/2000/svg" width="33.824" height="31.525" viewBox="0 0 33.824 31.525"><g transform="translate(1.058 0.759)"><path class="a" d="M54.992,49.821l8.314,6.125a1.051,1.051,0,0,0,1.674-.846V36.827a1.05,1.05,0,0,0-.612-.954L52.5,30.4a1.051,1.051,0,0,0-1.469.733L48.3,43.906a1.051,1.051,0,0,0,.4,1.062l6.3,4.852" transform="translate(-43.492 -30.298)"/><line class="b" x2="13.142" y2="25.496" transform="translate(7.448 0.599)"/><line class="b" x1="7.885" y2="3.68" transform="translate(12.063 6.195)"/><path class="a" d="M25.06,95.827S36.1,86.365,37.676,75.85l-7.885,3.68" transform="translate(-25.06 -66.578)"/><path class="a" d="M119.75,138.587a10.835,10.835,0,0,1,1.575-2.779,1.145,1.145,0,1,1,1.31,1.846A13.726,13.726,0,0,1,119.75,138.587Z" transform="translate(-99.617 -113.082)"/><path class="a" d="M107.275,146.98a10.8,10.8,0,0,1-1.27,2.931,1.144,1.144,0,1,1-1.5-1.7A13.833,13.833,0,0,1,107.275,146.98Z" transform="translate(-87.226 -121.998)"/><path class="b" d="M120.33,151.89a11.158,11.158,0,0,0,5.577,3.437,25.771,25.771,0,0,0,6.487.5" transform="translate(-100.394 -125.824)"/></g></svg>Hobby
            </th>
            <td>Testowanie technologii. Ma swój kanał na YouTube, gdzie rozwiązuje problemy technologiczne.</td>
            <td>Projektowanie. Sama zaprojektowałą swoją kuchnię.</td>
            <td>Kolekcjonowanie starej porcelany.</td>
            <td>Zbieranie grzybów.</td>
          </tr>
          <tr>
            <th>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35.5"
                height="31.5"
                viewBox="0 0 35.5 31.5"
              >
                <g transform="translate(0.75 0.75)">
                  <path
                    class="a"
                    d="M71.273,97.079H49.136a1.16,1.16,0,0,1-1.176-1.143V77.1H72.449V95.937A1.16,1.16,0,0,1,71.273,97.079Z"
                    transform="translate(-43.205 -67.079)"
                  />
                  <path
                    class="a"
                    d="M71.357,56.28H49.037a1.072,1.072,0,0,0-1.087,1.056v3.7H72.439v-3.7A1.067,1.067,0,0,0,71.357,56.28Z"
                    transform="translate(-43.197 -51.425)"
                  />
                  <path
                    class="a"
                    d="M94.348,40.218H89.59V35.986a.526.526,0,0,1,.526-.526h3.707a.526.526,0,0,1,.526.526Z"
                    transform="translate(-74.969 -35.46)"
                  />
                  <path
                    class="a"
                    d="M31.905,86.018H28.2a1.049,1.049,0,0,1-1.049-1.049V81.26h4.758v4.758Z"
                    transform="translate(-27.15 -70.58)"
                  />
                  <path
                    class="a"
                    d="M152.032,86.018h3.707a1.049,1.049,0,0,0,1.049-1.049V81.26H152.03v4.758Z"
                    transform="translate(-122.788 -70.58)"
                  />
                </g>
              </svg>Gotowanie
            </th>
            <td>Lubi gotować wykwintne i&nbsp;sezonowe dania.</td>
            <td>Lubi gotować na parze.</td>
            <td>Lubi wypieki.</td>
            <td>Lubi przygotowywać makarony i&nbsp;zapiekanki.</td>
          </tr>
          <tr>
            <th>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28.771"
                height="31.5"
                viewBox="0 0 28.771 31.5"
              >
                <g transform="translate(0.75 0.75)">
                  <path
                    class="a"
                    d="M63.729,61.3H38.642a1.092,1.092,0,0,1-1.092-1.092V32.392A1.092,1.092,0,0,1,38.642,31.3H63.729a1.092,1.092,0,0,1,1.092,1.092V60.208A1.092,1.092,0,0,1,63.729,61.3Z"
                    transform="translate(-37.55 -31.3)"
                  />
                  <rect
                    class="a"
                    width="17.021"
                    height="10.25"
                    transform="translate(5.126 15.457)"
                  />
                  <rect class="a" width="14.352" height="3.075" transform="translate(6.461 4.488)" />
                  <line class="a" x2="19.072" transform="translate(4.099 11.819)" />
                </g>
              </svg>Sprzęt kuchenny
            </th>
            <td>Musi być wielofunkcyjny i&nbsp;zaawansowany technologicznie.</td>
            <td>Ma być nie tylko ładny, ale też ułatwiać zachowanie porządku.</td>
            <td>Musi być wygodny i&nbsp;umożliwiać przygotowywanie kilku potraw na raz.</td>
            <td>Musi być intuicyjny.</td>
          </tr>
        </tbody>
      </table>
    </div>
       
  </div>
</template>

<script>
import videoCarousel from "./video_carousel";
export default {
  computed: {
    imageUrl: function() {
      return window.pageContentData.params.images["img-sec-2"];
    }
  },
  components: {
    videoCarousel
  }
};
</script>

<style lang="scss" scoped>
.section-wrapper {
  width: 100%;
  height: 100%;
  min-height: 400px;
  position: relative;
  align-items: center;
  padding: 5rem 0 4rem;
  display: flex;
  flex-direction: column;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(#ae0b11),
    to(#e41429)
  );
  background: linear-gradient(90deg, #ae0b11, #e41429);
  // z-index: 1;
  &::after {
    content: "";
    display: flex;
    width: 130px;
    height: 140px;
    background: url("../../../assets/images/zpl/splash-pink-faded-art.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    position: absolute;
    top: -70px;
    right: 26%;
    z-index: 2;
    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
  &::before {
    content: "";
    display: flex;
    width: 130px;
    height: 140px;
    background: url("../../../assets/images/zpl/splash-pink-faded.svg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    position: absolute;
    left: 2%;
    bottom: -103px;

    @media only screen and (max-width: 768px) {
      display: none;
    }
  }
  .sec8-trigger{
    position: absolute;
    bottom:-380px;
  
  }
  svg {
    width: 3rem;
    margin-right: 19px;
   
    .a,.b{fill:none;stroke:#e41429;stroke-linecap:round;stroke-miterlimit:10;stroke-width:1.5px;}.a{stroke-linejoin:round;}
  }

  @media only screen and (max-width: 1024px) {
    // min-height: auto;
    // height: auto;
    // padding: 4rem 0;
  }

  @media only screen and (max-width: 768px) {
    padding: 2rem 0;
  }
  .sec-8-title {
    display: flex;
    position: relative;
    width: 100%;
    justify-content: flex-end;

    .scroll-info {
      display: none;
      @media only screen and (max-width: 1180px) {
        display: flex;
        position: absolute;
        border-radius: 10px;
        bottom: -48px;
        right: 7%;
        font-size: 11px;
        color: #fff;
        text-transform: uppercase;
      }
    }
    h2 {
      width: 72%;
      display: inline-flex;
      color: #fff;
      font-size: 3rem;
      margin-bottom: 2rem;
      font-weight: 600;
      margin-top: auto;
      padding-right: 5%;
      position: relative;
      &::after {
        content: "";
        display: flex;
        width: 115px;
        height: 95px;
        background: url("../../../assets/images/zpl/dots-white.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        position: absolute;
        right: 3%;
        bottom: -45px;
        @media only screen and (max-width: 1366px) {
          display: none;
        }
      }

      @media only screen and (max-width: 1024px) {
        font-size: 2rem;
      }
    }
    @media only screen and (max-width: 768px) {
      justify-content: center;
      h2 {
        width: auto;
        text-align: center;
        padding-right: 0;
      }
    }
  }
  ::-webkit-scrollbar {
    width: 12px;
  }

  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  }
  .sec-8-table-wraper {
    display: flex;
    width: 88%;
    height: auto;
    align-items: center;
    margin-top: 4rem;
    overflow-x: auto;
    border-radius: 10px;

    table {
      border-collapse: separate !important;
      border-spacing: 0;
      background-color: #fff;
    }
    .sec-8-table {
      min-width: 1060px;
      margin: auto;
      border: solid #fff 2px;
      -moz-border-radius: 10px;
      -webkit-border-radius: 10px;
      border-radius: 10px;
      th,
      td {
        padding: 15px;
        vertical-align: center;
        border-bottom: 1px solid #e8e6e0;
      }

      thead {
        font-family: "Uni Neue", sans-serif;
        font-size: 18px;
        color: #e41429;

        th {
          background-color: rgb(245, 240, 240);
          width: 280px;
          height: 4rem;
        }
      }
      tbody {
        td {
          width: 280px;
          font-size: 14px;
        }
        th {
          color: #e41429;
          font-size: 16px;
          width: 300px;
          padding-right: 10px;

          vertical-align: baseline;
        }
      }
    }
    .sec-8-table th:first-child {
      -moz-border-radius: 10px 0 0 0;
      -webkit-border-radius: 10px 0 0 0;
      border-radius: 10px 0 0 0;
    }
    .sec-8-table th:last-child {
      -moz-border-radius: 0 10px 0 0;
      -webkit-border-radius: 0 10px 0 0;
      border-radius: 0 10px 0 0;
    }
    .sec-8-table th:only-child {
      -moz-border-radius: 10px 10px 0 0;
      -webkit-border-radius: 10px 10px 0 0;
      border-radius: 10px 10px 0 0;
    }
    .sec-8-table tr:last-child td:first-child {
      -moz-border-radius: 0 0 0 10px;
      -webkit-border-radius: 0 0 0 10px;
      border-radius: 0 0 0 10px;
    }
    .sec-8-table tr:last-child td:last-child {
      -moz-border-radius: 0 0 10px 0;
      -webkit-border-radius: 0 0 10px 0;
      border-radius: 0 0 10px 0;
    }
    .sec-8-table tbody tr:last-of-type,
    tbody tr:last-of-type th {
      border-bottom: none;
    }
  }
}
</style>
